(function () {
  'use strict';

  // ── Scroll class (drives category-nav hide + floating bar show) ─
  // RAF-throttled: one frame max, DOM only touched when state changes
  var lastScroll = 0;
  var scrollTicking = false;
  var bodyScrolled = false;

  function applyScrollState() {
    var y = window.scrollY;
    var shouldScroll = y > 80 && y > lastScroll;
    var shouldUnscroll = y < lastScroll || y < 40;

    if (shouldScroll && !bodyScrolled) {
      document.body.classList.add('dayum-scrolled');
      bodyScrolled = true;
    } else if (shouldUnscroll && bodyScrolled) {
      document.body.classList.remove('dayum-scrolled');
      bodyScrolled = false;
    }
    lastScroll = Math.max(y, 0);
    scrollTicking = false;
  }

  function onScroll() {
    if (!scrollTicking) {
      requestAnimationFrame(applyScrollState);
      scrollTicking = true;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  // ── Search overlay ─────────────────────────────────────────────
  function openSearch() {
    var overlay = document.getElementById('dayumSearchOverlay');
    if (!overlay) return;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      var inp = overlay.querySelector('.dayum-search-overlay__input');
      if (inp) inp.focus();
    }, 80);
  }

  function closeSearch() {
    var overlay = document.getElementById('dayumSearchOverlay');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) openSearch();
    if (e.target.closest('[data-search-close]')) closeSearch();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });

  // ── Cart open ──────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cart-open]')) return;
    e.preventDefault();
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      if (typeof cartDrawer.open === 'function') { cartDrawer.open(); return; }
      cartDrawer.removeAttribute('hidden');
      cartDrawer.setAttribute('open', '');
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:open'));
    window.dispatchEvent(new CustomEvent('cart:open'));
  });

})();
